<template>
  <hic-dialog append-to-body title="模块编辑" :visible="visible" @close="cancel" top="4vh" width="90%" @open="open" :close-on-click-modal="false">
    <el-form v-loading="loading" :model="value" :rules="comRules" ref="submitForm" label-width="6rem" label-position="right" style="padding-right: 3rem" size="mini">
      <el-row>
        <el-col :span="6">
          <el-form-item label="编码" prop="code">
            <el-tag v-if="value.id" style="width: 100%">
              <b>{{ value.code }}</b>
            </el-tag>
            <el-input v-else size="small" type="text" placeholder="请输入编码" v-model.trim="value.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="value.name" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用途" prop="purpose">
            <hic-dict-selector type="proxy_purpose" v-model="value.purpose" placeholder="请选择用途" size="small" clearable></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="说明" prop="">
            <el-input type="textarea" :rows="1" v-model="value.memo" placeholder="请输入说明" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-row v-for="(item, index) in mainSqls" :key="index">
          <el-col :span="24">
            <el-form-item label="SQL脚本" prop="">
              <el-input
                type="textarea"
                :rows="10"
                v-model="item.sql"
                placeholder="请输入SQL, 变量使用 {变量名} 的形式，变量值通过画面传递，前一画面传递给后一画面。其中首页始终给下一画面传递 {keyword}。另外，{tenantId} 不需要前一画面传递，后端会自动处理：添加查询条件 tenant_id = 当前用户租户ID。"
                size="small"
                clearable
              />
              <span v-if="index" type="warning" class="danger"> 若配置多个数据查询，需要保证所有配置中 SQL 语句返回的结构一致，最终结果将会以多个查询结果合并的形式返回</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数据库连接">
              <el-select size="small" v-model="item.code" placeholder="请选择数据库连接" style="width: 9rem">
                <el-option v-for="(item, index) in dataLinks" :key="index" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="返回值类型">
              <hic-dict-selector style="width: 9rem" dict-type="ResultType" placeholder="请选择" v-model="value.resultType" is-enum />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参数">
              <el-input type="textarea" :rows="1" v-model="lastParas" placeholder="JSON对象" size="small" style="width: 19rem"></el-input>
              <el-button type="danger" size="small" icon="el-icon-s-promotion" round @click="testSql(item)" class="left-pad">测 试</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参数脚本" prop="">
              <el-input type="textarea" :rows="10" v-model="value.roles" placeholder="参数处理脚本：固定使用方法 convert(Json字符串) 返回值为 Json字符串" size="small" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="返回值脚本" prop="">
              <el-input type="textarea" :rows="10" v-model="value.resultStruct" placeholder="返回值处理脚本：固定使用方法 convert(Json字符串) 返回值为 Json字符串" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路径" prop="resultType">
              <el-input v-model="apiUrl" placeholder="测试地址" size="small" clearable style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参数">
              <el-input type="textarea" :rows="1" v-model="apiParas" placeholder="JSON对象" size="small" style="width: 19rem"></el-input>
              <el-button type="success" size="small" icon="el-icon-s-promotion" round @click="testApi()" class="left-pad">测 试</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button :loading="loading" type="warning" @click="save(false)">暂 存</el-button>
      <el-button :loading="loading" type="primary" @click="save(true)">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        loading: false,
        dataLinks: [],
        mainSqls: [{ code: null, sql: null }],
        comRules: {
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          needPaging: [{ required: true, message: "请输入连接字符串", trigger: "blur" }],
          resultType: [{ required: true, message: "请选择数据类型", trigger: "change" }],
        },
        lastParas: null,
        apiUrl: null,
        apiParas: null,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
      paras() {
        let paras = [];
        this.mainSqls.forEach((item) => {
          if (/{.*?}/.test(item.sql)) {
            paras.push(...item.sql.match(/{.*?}/g));
          }
        });
        let obj = {};
        paras.forEach((key) => {
          obj[key.replace(/{|}/g, "")] = null;
        });
        delete obj.tenantId;
        return obj;
      },
    },
    methods: {
      open() {
        api.PxyDb.query({})
          .then((res) => {
            this.dataLinks = res.items.map((i) => ({ id: i.id, code: i.code, name: i.name }));
          })
          .catch((err) => {
            console.log(err);
          });

        try {
          this.$refs.submitForm.resetFields();
        } catch (error) {}

        if (this.value.dbSql) {
          this.$set(this, "mainSqls", JSON.parse(this.value.dbSql));
        } else {
          this.$set(this, "mainSqls", [{ code: null, sql: null }]);
        }
        this.lastParas = null;
        this.apiUrl = `/api/md/pxyQuery/${this.value?.code}/exec`;
        this.apiParas = null;
      },
      save(ifClose) {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.value.indexStart = this.value.indexStart ? 1 : 0;

            let sqls = this.mainSqls.filter((el) => {
              return el.code && el.sql;
            });
            if (!sqls.length) return this.$message.error("数据查询中缺少数据源配置！");
            this.$set(this.value, "dbSql", JSON.stringify(sqls));

            this.loading = true;
            api.PxyQuery.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.value.id = res.id;
                this.value.lockKey = res.lockKey;
                this.$emit("ok", res);
                if (ifClose) {
                  this.cancel();
                }
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      testSql(item) {
        if (!item.sql) {
          return;
        }
        if (!this.lastParas) {
          this.lastParas = this.lastParas || JSON.stringify(this.paras);
          return;
        }

        let obj = JSON.parse(this.lastParas);
        let para = {
          dbSqls: [item],
          resultType: this.value.resultType,
          indexStart: 1,
          param: {
            pageSize: 20,
            pageIndex: 1,
          },
        };
        Object.assign(para.param, obj);
        api.PxyQuery.execSql(para)
          .then((res) => {
            this.$message.success("通过");
            console.log(res);
          })
          .catch((err) => {
            this.$message.error("异常");
            console.log(err);
          });
      },
      testApi() {
        api.exec(this.apiUrl, this.apiParas ? JSON.parse(this.apiParas) : null);
      },
    },
  };
</script>
